import { customFetch } from '@agos/api-client'
import { useGetDeliveryZones } from '@agos/api-client/orders'
import { DELIVERY_QUOTE_PATH } from '@agos/shared'
import { useQuery } from '@tanstack/react-query'

import { zonesOf } from './delivery'
import { deliveryAreasOffered } from './delivery-areas'

/** The public delivery mode - one cached read, the checkout's own key, so the two share it. */
export function useDeliveryQuote() {
  return useQuery({
    queryKey: ['delivery-quote'],
    queryFn: () => customFetch<unknown>(DELIVERY_QUOTE_PATH),
    staleTime: 5 * 60_000,
  })
}

/**
 * Whether *Oblasti doručenia* is offered in the footer and the *Ďalšie* sheet - §9.799.
 *
 * The shell calls this once and hands the answer to both, as it does with the CMS pages.
 */
export function useDeliveryAreasOffered(): boolean {
  const { data: zoneData } = useGetDeliveryZones({ query: { staleTime: 5 * 60_000 } })
  const quote = useDeliveryQuote()
  return deliveryAreasOffered(zonesOf(zoneData), quote.data)
}
